/*eslint no-unused-vars: 0, arrow-parens: 0, indent: 0, semi: 0, no-useless-catch: 0*/
import axios, { AxiosAdapter, AxiosInstance } from "axios";
import Qs from "qs";
import _ from "../../compat/lodashplus";
import localPrint from "../../apps/common/LocalPrint";
import Cookies  from "js-cookie";
import config from "config/config";
import adapterErrorNetwork from "react-lib/apps/common/adapterErrorNetwork";

// Add this so apis can be called from node and return error for debug
// globalThis.Blob = Blob;

// Cannot get this to compile -> use windowany below instead
// declare global {
//   interface Window {
//       MobNative: any | undefined | null;
//   }
// }
// This might be due to incompatible react-scripts version
// But haven't changed it back to declare global yet

class BaseService {
  client: AxiosInstance;
  modalRef: any;

  static _interceptors = new Map();
  static addInterceptor(interceptor: any, callback: any) {
    BaseService._interceptors.set(interceptor, callback);
  }
  static removeInterceptor(interceptor: any) {
    BaseService._interceptors.delete(interceptor);
  }
  static _dispatchError(errorMessage: string) {
    BaseService._interceptors.forEach((callback) => {
      callback(errorMessage);
    });
  }
  constructor(apiToken: String | null = null) {
    // console.log('Prefer BaseService')
    this.modalRef = adapterErrorNetwork.getRef()
    this.client = axios.create({
      paramsSerializer: (params) =>
        Qs.stringify(params, { arrayFormat: "repeat" }),
      withCredentials: true,
    });
    this.client.interceptors.request.use(this._interceptRequest, (error) => {
      console.log("request use resolve")
      return error?.isLocal
        ? Promise.resolve(error) // <- triggers response intercept
        : Promise.reject(error);
    });
    if (apiToken) {
      console.log(
        "Base SErvice !!! Add Authorization !!! apiToken: ",
        apiToken
      );
      (this.client.defaults.headers as any)["Authorization"] = "Token " + apiToken;
    }

    // // compress
    // this.client.defaults.headers["Accept-Encoding"] = "gzip, deflate, br"
    // intercept a response error (500) and error
    this.client.interceptors.response.use((res) => {
      var headerText = res.headers;
      if (
        headerText["x-local-print"] &&
        !("pdf" in res.config && !res.config.pdf)
      ) {
        // logic เดียวกับ ในไส้ localPrint
        if (!config.USE_LOCAL_PRINT_BASE64) {
          console.log('localPrint without Token ');
          localPrint(res);
        } else {
          console.log('localPrint with Token ');
          localPrint(res, res?.config?.headers?.Authorization?.split(" ")?.[1]);
        }
      }

      // let isOffline = Cookies.get("offlineMode") === "offline";
      // // console.log('isOffline: ', isOffline);
      // // storing
      // if (res?.config?.method === "get" && res?.status === 200) {
      //   console.log("response res: ", res);

      //   let storeURL = new URL(res?.config.url);
      //   const queryParams: any = new URLSearchParams([
      //     ...Object.entries(res?.config.params),
      //   ]).toString();

      //   if (queryParams) {
      //     storeURL = new URL(`${storeURL}?${queryParams}`);
      //   }

      //   console.log(
      //     " Stored !!! to storeURL: ",
      //     storeURL
      //   );
      //   localStorage.setItem(
      //     storeURL?.href,
      //     JSON.stringify(res?.data)
      //   );
      // }
      return res;
    }, this._handleError);
  }
  // _consoleIntercept() {
  //   // console.log('BaseService._interceptors', BaseService._interceptors)
  // }
  setModalRef = (ref) => {
    this.modalRef = ref
  }

  _interceptRequest(config: any) {
    // intercept a request to handle pagination param
    if (
      config.params &&
      !_.has(config.params, "pagination_class") &&
      !config.url.includes("/o/") &&
      !config.url.includes("users/oauth/") &&
      !config.url.includes("redmine")
    ) {
      config.params.pagination_class = "page_number";
    }

    // console.log("_interceptRequest config: ", config);

    // let isOffline = Cookies.get("offlineMode") === "offline";

    // if (isOffline && config?.method === "get") {
    //   // read
    //   let storeURL = new URL(config.url);
    //   const queryParams: any = new URLSearchParams([
    //     ...Object.entries(config.params),
    //   ]).toString();

    //   if (queryParams) {
    //     storeURL = new URL(`${storeURL}?${queryParams}`);
    //   }

    //   let stored = localStorage.getItem(storeURL.href);
    //   console.log("Read !!! storeURL.href: ", storeURL.href);
    //   console.log("Read !!! storeURL.href result stored: ", stored);
    //   if (stored !== null) {
    //     console.log("Read !!! storeURL data:", stored);
    //     throw { isLocal: true, data: JSON.parse(stored) };
    //   }
    // }

    // intercept a request to handle a csrf token
    config.xsrfCookieName = "csrftoken";
    config.xsrfHeaderName = "X-CSRFToken";

    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    if (!isMobile) {
      let lang = Cookies.get("user_lang") 
      // if (!config.headers['Accept-Language']) { 
      config.headers['Accept-Language'] = lang === "th" ? "th-TH" : "en-US"; 
    }
    // console.log(" config", config)
    return config;
  }
  _readBlobAsText(blob: Blob) {
    return new Promise((res) => {
      const reader = new FileReader();
      reader.onload = () => res(reader.result);
      reader.readAsText(blob);
    });
  }
  _handleError = async (err: any) => {

    // Handle PrintURL Error (CU)
    const PRINT_REGEX = /print\//;
    // Opt-in for credentialed actions: shared error logging must never receive request data.
    if (err?.config?.sensitiveRequest) {
      return Promise.reject({
        isAxiosError: true,
        sensitiveRequest: true,
        message: "Sensitive request failed",
        response: { status: err.response?.status, data: err.response?.data ?? "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้" },
      });
    }
    console.log(" _handleError", err)
    if (PRINT_REGEX.test(err?.request?.responseURL)) {
      console.log("Found Print URL") 

      if (err?.response?.status === 500) {
        if (err?.response?.data?.includes("Printer not found")) {
          alert("ไม่สามารถเชื่อมต่อเครื่องพิมพ์ที่กำหนดไว้ กรุณาติดต่อสารสนเทศ")
        } else if (err?.response?.data?.incldues("ConnectionError: HTTPConnectionPool")) {
          alert("ไม่สามารถเชื่อมต่อ printserver กรุณาติดต่อสารสนเทศ")
        }
      }
    } else if (["post","put","patch"].includes(err?.config?.method || "") && err?.response?.status >= 500 && err?.message ) {
      this.modalRef(err)
    }

    if (err.isLocal) {
      console.log("_handleError err: ", err);
      return Promise.resolve(err); // <- send as successful response
    }
    if (err.response) {
      try {
        if (err.response.data instanceof Blob) {
          err.response.data = await this._readBlobAsText(err.response.data);
        }
      } catch (catchError) {
        throw catchError;
      }
    }
    if (err.response && [500, 503].includes(err.response.status)) {
      let data = err.response.data;
      let one = data.indexOf("Installed Applications:");
      let two = data.indexOf("Traceback:");
      let three = data.indexOf("META:");
      const message = `
          Internal Server Error ${err.response.status}\n
          ${data.substring(0, one)}\n
          ${data.substring(two, three)}
      `;
      BaseService._dispatchError(message.replace(/\r\n|\n|\r/gm, "\n"));
    }
    if (!err.response && err.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      // patch response.data to the error object
      const message = "Network Error: Maybe backend did not respond";
      err.response = { data: message };
      BaseService._dispatchError(message);
    }
    if (!err.response && !err.request) {
      // Something happened in setting up the request that triggered an Error
      err.response = { data: err.message };
    }
    return Promise.reject(err);
  };
  // used in subclass
  throwErrorMessage(error: any) {
    // console.log(" error.response", error.response)
    // console.log(" error.request.responseURL ",typeof(error.request.responseURL))
    let windowany: any = globalThis;
    const mobNative =
      typeof windowany.MobNative !== "undefined" ? windowany.MobNative : null;
    if (mobNative && error.response.status === 403) {
      let detail = error.response.data && error.response.data.detail;
      let msg =
        error.response.request.responseURL +
        "\n\n" +
        "Error Code:" +
        error.response.status +
        "\n\n response:" +
        detail;
      mobNative.alert(msg);
    }
    throw { responseData: error.response?.data, error: error,
      ...(error.sensitiveRequest ? { silent: true } : {}),
    };
  }
  handleResponse(response: any) {
    return { responseData: response.data, response: response };
  }
}
export default BaseService;
